import parse from 'html-react-parser'

/**
 * Receives an HTML string and looks for elements with the attribute data-replacer="...".
 * Replaces each found element with the corresponding React content from the replacements map.
 *
 * @param {string} htmlString - The HTML string to be parsed.
 * @param {Object.<string, React.ReactNode>} replacements - An object where the keys are the 'data-replacer' values
 * and the values are the React nodes to be inserted.
 * @returns {React.ReactElement|null} The parsed React nodes.
 */
export const renderReplacerTags = (htmlString, replacements) => {
  if (!htmlString || !replacements) return null

  return parse(htmlString, {
    replace: (domNode) => {
      if (domNode.type === 'tag' && domNode?.attribs?.['data-replacer']) {
        const replacerId = domNode.attribs['data-replacer']

        if (Object.prototype.hasOwnProperty.call(replacements, replacerId)) {
          return replacements[replacerId]
        }
      }
      return undefined
    }
  })
}
